import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum ThreadStatusEnum {
    New = 0,
    InReview = 1,
    Resolved = 2
}

export enum ThreadStatusNameEnum {
    "New" = ThreadStatusEnum.New,
    "In Review" = ThreadStatusEnum.InReview,
    "Resolved" = ThreadStatusEnum.Resolved
}

export class ThreadStatusEnumClass extends EnumWithDescription<ThreadStatusEnum> {
    public readonly enum = ThreadStatusEnum;
    public readonly enumName: string = "ThreadStatus";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<ThreadStatusEnum>> = new Map([
        [
            "New",
            {
                value: ThreadStatusEnum.New,
                name: "New"
            }
        ],
        [
            "InReview",
            {
                value: ThreadStatusEnum.InReview,
                name: "In Review"
            }
        ],
        [
            "Resolved",
            {
                value: ThreadStatusEnum.Resolved,
                name: "Resolved"
            }
        ]
    ]);
}

export const ThreadStatus = new ThreadStatusEnumClass();
